import React, { useState } from "react";
import { timeConverter } from "../../../utils/timeConverter";
import { useLazyQuery, useQuery } from "@apollo/client";
import { PDFDownloadLink } from '@react-pdf/renderer';
import { useMediaQuery } from "../../../utils/deviceChecker";
import { GET_EVENTS_FOR_HOST, GET_RSVP_FOR_HOST_EVENT } from "../gql/queries";
import EventListPdfDocument from "./EventRsvpListPdf";
import { useNavigate } from "react-router-dom";
import SectionHeader from "../../../components/SectionHeader";

const HostsEvents = () => {
    const navigate = useNavigate();

    const { data: hostsEventsData } = useQuery(GET_EVENTS_FOR_HOST);
    const hostsEvents = hostsEventsData?.hostsEvents || [];

    const isDesktop = useMediaQuery("(min-width: 1258px)");

    const [getRsvpsForHostsEvents, { data: rsvpData }] = useLazyQuery(GET_RSVP_FOR_HOST_EVENT, { variables: { eventId: "" } });

    const showGenerateButtons = () => {
        let allGenerateDivs = document.getElementsByClassName("generateDiv");
        if (allGenerateDivs.length > 0) {
            for (let i = 0; i < allGenerateDivs.length; i++) {
                allGenerateDivs[i].style.display = "none";
            }
        }
        let allGenerateBtns = document.getElementsByClassName("generateBtn");
        if (allGenerateBtns.length > 0) {
            for (let i = 0; i < allGenerateBtns.length; i++) {
                allGenerateBtns[i].style.display = "block";
            }
        }
    }

    const fetchRsvpCount = async (event) => {
        showGenerateButtons();
        let id = event.target.id;
        const generateButton = document.querySelector(`#button${id}`)
        generateButton.style.display = "none";
        const generateDiv = document.querySelector(`#countAndLinkInfo${id}`);
        generateDiv.style.display = 'flex'
        generateDiv.className = 'generateDiv'
        await getRsvpsForHostsEvents({
            variables: { eventId: id }
        });
    }

    const isShowButtons = (rsvpData, buttonId) => {
        if (rsvpData === null) {
            console.log("No data found for list generation");
            return false;
        }
        if (rsvpData.rsvpsForHostsEvents === undefined || rsvpData.rsvpsForHostsEvents.length === 0) {
            console.log("No data found for list generation");
            return false;
        }
        return rsvpData.rsvpsForHostsEvents.eventId === buttonId;
    };

    return (
        <>
            <SectionHeader title="Manage My Events" className='sectionHeader' />
            <div className="dishContainer">
                {
                    hostsEvents && hostsEvents.length > 0 ? hostsEvents.map((event) => (
                        <>
                            <div id="hostEventsRow" className="dishesRow">
                                <p className="miqaatText">{event.title}</p>
                                <p>{timeConverter(event.date)}, {event.time}</p>
                                <div id={"form" + event._id} className="generateBtnForm">
                                    <div id={"button" + event._id} className="generateBtn">
                                        <button className="generateButtons" onClick={() => navigate(`/editEvent/${event._id}`)}>Edit</button>
                                        <button className="generateButtons" onClick={() => window.location.href = `/manageEvent/${event._id}`}>Invite</button>
                                        <button id={event._id} className="generateButtons" onClick={fetchRsvpCount}>Counts</button>
                                    </div>
                                    {isDesktop ? (
                                        <div id={"countAndLinkInfo" + event._id}>
                                            {rsvpData && isShowButtons(rsvpData, event._id) && (
                                                <>
                                                    <p>Men:&nbsp;<b>{rsvpData.rsvpsForHostsEvents?.menCount}</b></p>
                                                    <p>Women:&nbsp;<b>{rsvpData.rsvpsForHostsEvents?.womenCount}</b></p>
                                                    <p>Children:&nbsp;<b>{rsvpData.rsvpsForHostsEvents?.childrenCount + rsvpData.rsvpsForHostsEvents?.toddlerCount}</b></p>
                                                    <p>Thaals:&nbsp;<b>{Math.floor((rsvpData.rsvpsForHostsEvents?.menCount + rsvpData.rsvpsForHostsEvents?.womenCount + rsvpData.rsvpsForHostsEvents?.childrenCount) / 8) + (((rsvpData.rsvpsForHostsEvents?.menCount + rsvpData.rsvpsForHostsEvents?.womenCount + rsvpData.rsvpsForHostsEvents?.childrenCount) % 8 > 5) ? 1 : 0)}</b></p>
                                                    <PDFDownloadLink
                                                        fileName={"List-" + event.title.replace(/\s/g, '') + ".pdf"}
                                                        document={<EventListPdfDocument data={rsvpData} />}
                                                        className="csvLink">List</PDFDownloadLink>
                                                </>
                                            )}
                                        </div>
                                    ) : (
                                        <div id={"countAndLinkInfo" + event._id}>
                                            {rsvpData && isShowButtons(rsvpData, event._id) && (
                                                <div className="rsvpDataCounts">
                                                    <p>Men:&nbsp;<b>{rsvpData.rsvpsForHostsEvents?.menCount}</b></p>
                                                    <p>Women:&nbsp;<b>{rsvpData.rsvpsForHostsEvents?.womenCount}</b></p>
                                                    <p>Children:&nbsp;<b>{rsvpData.rsvpsForHostsEvents?.childrenCount + rsvpData.rsvpsForHostsEvents?.toddlerCount}</b></p>
                                                    <p>Thaals:&nbsp;<b>{Math.floor((rsvpData.rsvpsForHostsEvents?.menCount + rsvpData.rsvpsForHostsEvents?.womenCount + rsvpData.rsvpsForHostsEvents?.childrenCount) / 8) + (((rsvpData.rsvpsForHostsEvents?.menCount + rsvpData.rsvpsForHostsEvents?.womenCount + rsvpData.rsvpsForHostsEvents?.childrenCount) % 8 > 5) ? 1 : 0)}</b></p>
                                                    <PDFDownloadLink
                                                        fileName={"List-" + event.title.replace(/\s/g, '') + ".pdf"}
                                                        document={<EventListPdfDocument data={rsvpData} />}
                                                        className="csvLink">List</PDFDownloadLink>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <hr className="dishRowLine" />
                        </>
                    )) : <p className="errMsg hosts-events-empty-message">
                        You are not hosting any upcoming events
                    </p>
                }
            </div>
        </>
    );
}

export default HostsEvents;